export default function ActivitesClasses() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">Activités des classes</h1>
      <p className="mt-4 text-slate-700">Découvrez les activités par année scolaire.</p>
      <ul className="mt-6 space-y-2 text-amber-700 font-semibold">
        <li><a className="hover:underline" href="https://www.lavoielactee.ch/activitees-des-classes">Voir sur le site d'origine</a></li>
      </ul>
      <div className="mt-6 grid sm:grid-cols-2 gap-3">
        {["2024-2025","2022-2023","2021-2022","2020-2021","2019-2020","2018-2019","2017-2018"].map(y => (
          <div key={y} className="p-4 border rounded-xl bg-white hover:bg-orange-50">Année scolaire: {y}</div>
        ))}
      </div>
    </main>
  );
}